var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.64,
    height: 17.639,
    viewBox: "0 0 17.64 17.639",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-345.04 -541.983)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_15550",
    "data-name": "Path 15550"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15563",
    "data-name": "Path 15563",
    d: "M358.552,559.622H347.6a2.566,2.566,0,0,1-2.564-2.563V546.11a2.566,2.566,0,0,1,2.564-2.563h4.176a1,1,0,0,1,0,2H347.6a.564.564,0,0,0-.564.563v10.949a.564.564,0,0,0,.564.563h10.948a.564.564,0,0,0,.564-.563v-4.176a1,1,0,0,1,2,0v4.176A2.567,2.567,0,0,1,358.552,559.622Z",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_15551",
    "data-name": "Path 15551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15564",
    "data-name": "Path 15564",
    d: "M353.86,554.931h-3.128a1,1,0,0,1-1-1V550.8a1,1,0,0,1,.293-.707l7.82-7.821a1,1,0,0,1,1.414,0l3.128,3.128a1,1,0,0,1,0,1.414l-7.82,7.821A1,1,0,0,1,353.86,554.931Zm-2.128-2h1.714l6.82-6.821-1.714-1.714-6.82,6.821Z",
    fill: "currentColor"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.16ed057612a02245d9acddcaecacdb74.svg";
export { ForwardRef as ReactComponent };